export const PFLEGEHILFSMITTEL_PAUSCHALE = 42;
